import React, { useEffect, useMemo, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import '../../css/ComparisonResults.css';
import MainWrapper from '../wrappers/mainWrapper';
import Button from '@mui/material/Button';
import Multiselect from 'multiselect-react-dropdown';
import Modal from 'react-modal';
import axios from 'axios'
import jsPDF from 'jspdf'
import LevlrLogo from '../../img/LEVLR Logo_CMYK.png'
import Select from 'react-select';
import GO from '../../img/Go.png';
import Close from '../../img/pretty-close-2.png';
import Stop from '../../img/_Stop.png';
import Yield from '../../img/_Yield.png';
import ZoneDisplay1 from '../zoneDisplay1'; 
import ZoneDisplay2 from '../zoneDisplay2';

const ComparisonResults = props => {

  const isMounted = useRef(false);
  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  let doc1ZoneState = []
  const [newZonesToCompare, setNewZonesToCompare] = useState([])
  var stringSimilarity = require("string-similarity");
  const [responded, setResponded] = useState(false)
  const [getSubzones, setGetSubzones] = useState([])
  const [data, dataSet] = useState({})
  const [filter, setFilter] = useState("percentage");
  const [percentValue, setPercentValue] = useState(43.0);
  const [currentSection, setCurrentSection] = useState("results");
  const { comparisonID } = useParams();
  const [markForExport, setMarkForExport] = useState(new Set)
  const [open, setOpen] = useState(false)
  const [currentNoteId, setCurrentNoteId] = useState("")
  const [loadingStatus, setLoadingStatus] = useState('loading-spinner')
  const pdfRef = useRef(null);
  const MAX = 85;
  const [noteLog, setNoteLog] = useState([])
  const [currentNote, setCurrentNote] = useState("")
  const [markConfirm, setMarkConfirm] = useState(new Set)
  const [markAllCheckboxes, setMarkAllCheckboxes] = useState(new Set)
  const [newViewArray, setNewViewArray] = useState([])
  const [pdfCopyContent, setPdfCopyContent] = useState(false);
  const [doc1Name, setDoc1Name] = useState("");
  const [doc2Name, setDoc2Name] = useState(""); 
  const [zonesInitialized, setZonesInitialized] = useState(false);
  //console.log("data: " + JSON.stringify(data,null,2))

  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);  
  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [doc2Visibility, setDoc2Visibility] = React.useState({});

  const toggleDoc2Visibility = (key) => {
    setDoc2Visibility((prevState) => ({
      ...prevState,
      [key]: !prevState[key],  // Toggle visibility per item
    }));
  };

  const [toggled, setToggled] = useState(true)
  const maxLength = 60; // Set the maximum length for visible content

  const [selectedZone1, setSelectedZone1] = useState([]);
  const [selectedZone2, setSelectedZone2] = useState([]);
  const [filterTextZone1, setFilterTextZone1] = useState(''); // State for zone 1 filter text
  const [filterTextZone2, setFilterTextZone2] = useState(''); // State for zone 2 filter text
  const [filteredItems, setFilteredItems] = useState({ zone1: [], zone2: [] });
  const [confirmedForExport, setConfirmedForExport] = useState([]);
  //console.log("markForExport: " + JSON.stringify(Array.from(markForExport), null, 2));
  //console.log("confirmedForExport: " + confirmedForExport)
  //console.log("markConfirm: " + JSON.stringify(markConfirm,null,2))
  const openPreviewInNewTab = () => {
    const pdfCopy = document.getElementById('pdfCopy');

    if (pdfCopy) {  
      // Clone the pdfCopy content to avoid modifying the original
      const clonedContent = pdfCopy.cloneNode(true);
      
      // Remove all label elements within the cloned content
      const labels = clonedContent.querySelectorAll('label');
      labels.forEach((label) => label.remove());

      // Open a new tab and inject the modified content
      const newTab = window.open('', '_blank');
      newTab.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Preview</title>
        <style>
          /* Add any styling you want for the preview here */
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
          }
        </style>
      </head>
      <body>
        ${clonedContent.innerHTML}
      </body>
      </html>
    `);
      newTab.document.close(); // Ensure the document is fully loaded
    } else {
      alert('No content to preview');
    }
  };

  //Generate PDF from pdfCopy which is used to populte the preview
  const generatePDF = () => {
    const pdfCopy = document.getElementById('pdfCopy');
    const pdfCopyClone = pdfCopy.cloneNode(true);
  
    if (!pdfCopyClone || pdfCopyClone.children.length === 0) {
      alert('No selections made for export.');
      return;
    }
  
    const fileName = prompt('Please Enter A File Name.') || 'claim-export';
  
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'px',
      format: 'a1',
      hotfixes: ['px_scaling'],
    });
  
    // Temporarily unhide the content for rendering
    pdfCopyClone.style.display = 'block';
    pdfCopyClone.style.visibility = 'visible';
    pdfCopyClone.style.opacity = '1';
    pdfCopyClone.style.position = 'static';
  
    // Group tables into chunks of 5
    const allTables = Array.from(pdfCopyClone.querySelectorAll('table'));
    const chunks = [];
    for (let i = 0; i < allTables.length; i += 5) {
      chunks.push(allTables.slice(i, i + 5));
    }
  
    const renderNextChunk = (index = 0) => {
      if (index >= chunks.length) {
        doc.save(`${fileName}.pdf`);
        pdfCopyClone.style.display = 'none';
        return;
      }
  
      // Clear pdfCopy and insert 5 tables
      pdfCopyClone.innerHTML = '';
      chunks[index].forEach(table => pdfCopyClone.appendChild(table));
  
      // Skip addPage() on first render to avoid blank page
      if (index > 0) {
        doc.addPage();
      }
  
      doc.html(pdfCopyClone, {
        autoPaging: false,
        margin: [40, 40, 40, 40],
        x: 0,
        y: 0,
        width: 2200,
        windowWidth: 2000,
        callback: function () {
          // Add claim data on first page only
          if (index === 0 && data?.claimData) {
            const { adjuster, insured, insured_address, claim_number } = data.claimData;
            doc.setPage(1); // Ensure you're on first page
            doc.setFontSize(14);
            doc.setTextColor('#333');
            doc.setFont('helvetica', 'normal');
            doc.text(`Adjuster: ${adjuster}`, 40, 50);
            doc.text(`Insured: ${insured}`, 40, 75);
            doc.text(`Insured Address: ${insured_address}`, 40, 100);
            doc.text(`Claim Number: ${claim_number}`, 40, 125);
  
            doc.addImage(LevlrLogo, 'PNG', 2000, 30, 150, 50);
            doc.setFontSize(16);
            doc.setTextColor('#00AEEF');
            doc.setFont('helvetica', 'bold');
            doc.text('getlevlr.com', 2000, 100);
          }
          else{
            doc.addImage(LevlrLogo, 'PNG', 2000, 30, 150, 50);
            doc.setFontSize(16);
            doc.setTextColor('#00AEEF');
            doc.setFont('helvetica', 'bold');
            doc.text('getlevlr.com', 2000, 100);
          }
          renderNextChunk(index + 1);
        },
      });
    };
  
    renderNextChunk();
  };
  
//styles
const tableStyle = { 
  position: 'relative',
  height: 'auto',
  width: '100%',
  backgroundColor: '#DDDDDD',
  borderRadius: '4px',
  padding: '12px 8px',
  margin: '12px 12px 24px 12px',
  overflow: 'auto',
  border: '1px dotted black'
}
const filterTableStyle = {
  position: 'relative',
  height: 'auto',
  width: '98%',
  backgroundColor: '#DDDDDD',
  borderRadius: '4px',
  padding: '12px 8px',
  margin: '12px 0px 24px 0px',
  overflow: 'auto',
  border: '1px dotted black'
}
const modalStyle = {
  position: 'absolute',
  display: 'grid',
  overflow: 'hidden',
  backgroundColor: 'white',
  opacity: '95%',
  width: '100%',
  height: '100%',
  borderRadius: '15px',
  padding: '12px 12px',
  boxSizing: 'border-box'
}

const modalRestyle = {
  overlay: {
    width: '40%',
    height: '44%',
    top: '54%',
    left: '1%',
    overflow: 'hidden',
    borderRadius: '15px',
    border: '4px solid black',
    boxSizing: 'border-box',
    padding: '0 0',
  },

  content: {
    overflow: 'hidden',
    background: 'none',
    border: 'none',
    inset: '0px',
    padding: '0 0'
  },
}

const noteStyle = {
  border: '2px solid #526666',
  resize: 'none',
  fontSize: '20px',
  padding: '4px 4px',
  width: '100%',
  height: '100%',
  boxSizing: 'border-box'
}

const notInAnyZone = {
  fontSize: '24px',
  textAlign: 'center',
  padding: '0px 0px',
  margin: '0px 0px'
}

const endOfDocTable = {
  position: 'relative',
  height: 'auto',
  width: '100%',
  backgroundColor: '#e7d4d8',
  borderRadius: '4px',
  margin: '12px 24px 24px 0px',
  padding: '12px 8px',
  overflow: 'auto',
  border: '1px dotted black',
}

const pdfCopy = {
  display: 'flex-box',
  flexDirection: 'column',
  margin: '128px 12px 12px 12px',
  padding: '16px',
  fontSize: '28px',
  width: '100%',
  overflowY: 'auto',
  boxSizing: 'border-box'
}

const theadStyle = {
  fontSize: '20px'
}

const newHeaderStyle = {
  fontSize: '32px',
  paddingBottom: '12px'
}

const borderTop = {
  position: 'relative',
  gridTemplateRows: 'auto auto',
  height: 'auto',
  width: '100%',
  borderRadius: '4px',
  borderTop: '2px solid black',
  marginTop: '36px'
}

const getZonePairingsContainer = {
  display: 'block',
}

const noMatchTableStyle = {
  position: 'relative',
  height: 'auto',
  width: '100%',
  backgroundColor: '#e7d4d8',
  borderRadius: '4px',
  padding: '12px 8px',
  margin: '12px 24px 24px 0px',
  overflow: 'auto',
  border: '1px dotted black'
}

const lastRow = {
  display: 'flex',
  justifyContent: 'space-between',
  gridTemplateColumns: 'auto',
  width: '100%',
  alignItems: 'center',
  padding: '4px 4px'
}

const filterStyle = {
  height: '16px',
  padding: '6px'
}

const centeredHeader = {
  textAlign: 'center'
}

const blockStyle = {
  display: 'block'
}

const mapStyle = {
  position: 'relative',
  height: 'auto',
  display: 'grid',
  gridTemplateRows: 'auto auto',
  marginTop: '6px',
}

const verticalLabel = {
  padding: '16px 4px',
  margin: '4px 4px',
  textAlign: 'center',
  border: 'none',
  fontStyle: 'italic',
  opacity: '50%',
  textDecoration: 'underline'
}

const labelStyle = {
  margin: '12px 0px',
  color: '#00B3B5',
  textAlign: 'left'
}

const doc2ZoneStyle = {
  display: 'flex',
  justifyContent: 'center',
  textAlign: 'center',
  fontWeight: 'bold',
  color: '#00B3B5', 
  textDecoration: 'underline',
  fontSize: '24px'
}

const addNoteButton = {
  backgroundColor: '#00B3B5',
  color: 'white',
  borderRadius: '4px',
  padding: '4px 8px',
  margin: '0px 8px',
  display: 'inline',
  width: '20%',
  minWidth: '180px !important',
}

const updateNoteButton = {
  backgroundColor: '#723E49',
  color: 'white',
  borderRadius: '4px',
  padding: '4px 8px',
  margin: '0px 8px',
  display: 'inline',
  width: '20%'
}

const zoneStyle = {
  margin: '12px 0px',
  fontWeight: 'bold',
  fontSize: '1em',
  padding: '2px 12px',
  color: '#526666'
}

const thStyle = {
  fontWeight: 'bold',
  fontStyle: 'italic',
  color: '#526666',
  border: 'none',
  textAlign: 'left',
  alignSelf: 'center'
}

const trStyle = {
  width: '100%',
  padding: '0px 0px',
  display: 'flex',
  justifyContent: 'space-between'
}

const exportButtons = {
  display: 'flex',
  position: 'fixed',
  margin: '0 auto',
  padding: '0 48px',
  boxSizing: 'border-box',
  justifyContent: 'flex-end',
  width: '85%',
  zIndex: '1000',
  top: '10%',
  left: '15%'
}

const trStyleFlexStart = {
  width: '100%',
  padding: '0px 0px',
  display: 'flex',
  justifyContent: 'flex-start'
}

const tbodyStyle = {
  overflow: 'auto',
  display: 'inline'
}

const tbodyNote = {
  overflow: 'auto',
  display: 'inline',
  marginTop: '24px',
  inlineSize: '80%',
  wordBreak: 'break-all',
  fontWeight: 'bold',
  fontSize: '18px',
}

const tdPropStyle = {
  display: 'block',
  margin: '0px 0px',
  color: '#00B3B5',
  textAlign: 'left',
}

const tdValueStyle = {
  color: '#526666',
}

const containsPropVal = {
  display: 'block',
  width: '200px',
  overflow: 'auto',
  padding: '0 4px',
  margin: '12px 0px 0px 0px'
}  
// 1. Initial data loading effect
useEffect(() => {
  getSubzonesData();
  getNotesData();
  getConfirmData();
  
  if (!responded) {
    getResultsData();
  }
}, [responded]); // Only re-run if responded changes

// 2. Zone initialization effect - runs once data is ready
useEffect(() => {
  if (!responded) return; // Wait for data to be ready
  
  if (!zonesInitialized) {
    if (getSubzones.length > 0) {
      setNewZonesToCompare(getSubzones[0].stateObject);
    } else if (data.results) { // Make sure data.results exists before using bestMatch
      const fallback = doc1ZoneState.map((val, index) => ({
        Id: index,
        Doc1: val,
        SubZones: [],
      }));
      setNewZonesToCompare(fallback);
    }
    setZonesInitialized(true);
    setLoadingStatus('');
  }
}, [responded, getSubzones, zonesInitialized, data.results]);

// 3. Render zones effect - runs when zones or data changes
useEffect(() => {
  if (responded && zonesInitialized) {
    renderZones();
  }
}, [responded, zonesInitialized, newZonesToCompare, data]);

// 4. Filter line items effect
useEffect(() => {
  if (data.results) {
    filterLineItems();
  }
}, [data.results, selectedZone1, selectedZone2, filterTextZone1, filterTextZone2]);

// 5. Before unload handler for notes
useEffect(() => {
  const handler = (event) => {
    event.preventDefault();
    event.returnValue = '';
  };
  
  if (noteLog.length > 0) {
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }
}, [noteLog]);

// 6. PDF content effect
useEffect(() => {
  const pdfCopy = document.getElementById('pdfCopy');
  if (pdfCopy) {
    setPdfCopyContent(pdfCopy.childElementCount > 0);
  }
}, []);

// 7. Export status effect
useEffect(() => {
  setConfirmedForExport(markForExport);
}, [markForExport]);

const getResultsData = async () => {
  try {
    const comp = await fetch(`${process.env.REACT_APP_RESULTS_DATA}comp/${comparisonID}`, { timeout: 8000 })
      .then((response) => response.json());

    const split = await fetch(`${process.env.REACT_APP_SPLIT_RESULTS}/${comp.resultsID}`)
      .then((response) => response.json());

    if (!isMounted.current) return;

    dataSet({
      results: JSON.parse(split.data),
      claimData: comp.claimData,
      files: comp.files,
      headers: comp.headers,
      resultsID: comp.resultsID,
      dateUploaded: comp.dateUploaded,
      statusMSG: comp.statusMSG,
      status: comp.status,
      doc1_name: comp.doc1_name,
      doc2_name: comp.doc2_name,
      headersOne: comp.headersOne,
      headersTwo: comp.headersTwo,
      no_match_a: comp.no_match_a,
      no_match_b: comp.no_match_b
    });

    setDoc1Name(comp?.claimData?.doc1_name);
    setDoc2Name(comp?.claimData?.doc2_name);
    setResponded(true);
  } catch (err) {
    console.error("Error fetching results data:", err);
  }
};


  //Function to collect subzone record
  const getSubzonesData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_GET_SUBZONES}${comparisonID}`,
        { timeout: 8000 }
      ).then((res) => res.json());
  
      if (!isMounted.current) return; // ✅ Prevent state update after unmount
  
      setGetSubzones(response);
    } catch (error) {
      console.error("Error fetching subzones:", error);
    }
  };
  

  //Function to collect subzone record
  const getNotesData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_GET_NOTES}${comparisonID}`, 
        { timeout: 8000 }
      ).then((res) => res.json());
  
      if (!isMounted.current) return; // prevent state update if unmounted
  
      if (Object.keys(response).length > 0) {
        setNoteLog(response[0]["stateObject"]);
      }
    } catch (err) {
      console.error("Error fetching notes data:", err);
    }
  };
  

  const getConfirmData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_GET_CONFIRM}${comparisonID}`,
        { timeout: 8000 }
      ).then((res) => res.json());
  
      if (!isMounted.current) return; // ✅ Prevent state update on unmounted component
  
      if (Object.keys(response).length > 0) {
        setMarkConfirm(response[0]["stateObject"]);
      }
    } catch (error) {
      console.error("Error fetching confirmation data:", error);
    }
  };
  

  //Function to put subzones into database
  //id param is equal to comparisonID
  function handleSaveZones(id) {
    axios.put(`${process.env.REACT_APP_SAVE_ZONES}${id}`, newZonesToCompare)
      .then(response => {
        //alert("Zones Saved To Database!");
        //console.log("Zones Posted.");
      })
      .catch(error => {
        // alert("Saving was unsuccessful. Please try again.");
        // console.error('There was an error!', error);
      });
  }

  function handleSaveNotes(id) {
    //console.log("📤 Submitting Notes to API:", noteLog);
    axios.put(`${process.env.REACT_APP_SAVE_NOTES}${id}`, noteLog)
      .then(response => {
        // alert("Notes Saved To Database!");
      })
      .catch(error => {
        // alert("Saving was unsuccessful. Please try again.");
       //  console.error('❌ Error saving notes:', error);
      });
  }


  function handleSaveConfirm(id) {
    axios.put(`${process.env.REACT_APP_SAVE_CONFIRM}${id}`, markConfirm)
      .then(response => {
        //alert("No-Matches Saved To Database!");
        //console.log("No-Matches Posted.");
      })
      .catch(error => {
        // alert("Saving was unsuccessful. Please try again.");
        //console.error('There was an error!', error);
      });
  }

  function saveChanges(id) {
    handleNoteSave((updatedNoteLog) => {
      // Use updated noteLog immediately
      //console.log("✅ Forcing sync submit of updated notes:", updatedNoteLog);
      axios.put(`${process.env.REACT_APP_SAVE_NOTES}${id}`, updatedNoteLog)
        .then(() => alert("Changes Saved To Database"))
        .catch((error) => {
          alert("Saving was unsuccessful. Please try again.");
          //console.error('❌ Error saving notes:', error);
        });
  
      handleSaveZones(id);
      handleSaveConfirm(id);
    });
  }


  const openNote = (e, id) => {
    setCurrentNoteId(id);
    const existing = noteLog.find(note => note.id === id);
    setCurrentNote(existing ? existing.note : ""); // ✅ reset to existing or empty
    setOpen(true);
  };
  
  const updateNote = (e, id) => {
    //console.log("🔵 Opening Update Note modal for ID:", id);
    const existing = noteLog.find(note => note.id === id);
    //console.log("🧠 Existing Note (if any):", existing);
    setCurrentNoteId(id);
    setCurrentNote(existing ? existing.note : "");
    setOpen(true);
  };


  function findPlaceholderText(id) {
    if (noteLog.find((element) => {
      return (element.id === id);
    })) {
      return (
        noteLog.find((element) => {
          return (element.id === id);
        })
      ).note
    }
    else return

  }

  function renderAddOrUpdate(currentNoteId) {
    if (findPlaceholderText(currentNoteId) === undefined) {
      return false
    }
    else {
      if (findPlaceholderText(currentNoteId).length > 0) {
        return true
      }
    }
  }

  function renderNote() {
    return (
      <Modal
        style={modalRestyle}
        isOpen={open}
        onRequestClose={() => handleNoteClose()}
        preventScroll={false}
        ariaHideApp={false}
      >
        <div style={modalStyle}>
          <h3 style={{ color: '#526666' }}>{renderAddOrUpdate(currentNoteId) ? "Please Update Your Note." : "Please Add A Note."}</h3>
          <textarea
            style={noteStyle}
            id={currentNoteId}
            name={currentNoteId}
            value={currentNote}
            rows="8"
            cols="50"
            onFocus={() => {
              if (currentNote === "") {
                const existing = noteLog.find(note => note.id === currentNoteId);
                setCurrentNote(existing ? existing.note : "");
              }
            }}
            onChange={handleNoteChange}
          >

          </textarea>

          <Button
            size="small"
            sx={{
              ':hover': {
                backgroundColor: '#999999'
              },
              height: '50px',
              margin: '16px 0px 0px 0px',
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: '#00B3B5'
            }}
            onClick={() => {
              handleNoteSave();           // just saves locally
              saveChanges(comparisonID);  // submits all notes (and subzones/confirm)
            }}
          >
            {renderAddOrUpdate(currentNoteId) ? "UPDATE NOTE" : "ADD NOTE"}
          </Button>

          <Button
            size="small"
            sx={{
              ':hover': {
                backgroundColor: '#999999'
              },
              margin: '0px 0px 8px 0px',
              fontWeight: 'bold',
              height: '50px',
              color: 'white',
              backgroundColor: '#723E49'
            }}
            onClick={handleNoteClose}
          >
            Exit
          </Button>
        </div>
      </Modal>
    )

  }

  function handleNoteClose() {
    setOpen(false)
  }

  const handleNoteChange = (e) => {
    //console.log("📝 Typing Note:", e.target.value);
    setCurrentNote(e.target.value);
  };
  

  const handleNoteSave = (maybeCallback) => {
    const newNote = { id: currentNoteId, note: currentNote };
    const index = noteLog.findIndex(note => note.id === currentNoteId);
  
    let updated;
    if (index === -1) {
      updated = [...noteLog, newNote];
      setNoteLog(updated);
      //console.log("📌 Adding new note to noteLog");
    } else {
      updated = [...noteLog];
      updated[index] = newNote;
      setNoteLog(updated);
      //console.log("♻️ Updating existing note in noteLog");
    }
  
    setOpen(false);
  
    // ✅ only call if it's actually a function
    if (typeof maybeCallback === "function") {
      maybeCallback(updated);
    }
  };

  function checkDisabledNote(id) {
    if ((noteLog.find(note => note['id'] === id)) === undefined) {
      return false
    }
    else {
      return true
    }
  }

  function renderClaimCredentials() {
    if (data["claimData"] != null || data["claimData"] != undefined) {
      return (
        <div style={newHeaderStyle} id={'newHeader'}>
          <p>Adjuster : {data["claimData"]["adjuster"]}</p>
          <p>Insured : {data["claimData"]["insured"]}</p>
          <p>Insured Address : {data["claimData"]["insured_address"]}</p>
          <p>Claim Number : {data["claimData"]["claim_number"]}</p>
        </div>
      )
    }
    else {
      return
    }
  }

  function renderAddNote(id) {
    if (!checkDisabledNote(id)) {
      return (
        <Button
          id={id}
          style={{ ...addNoteButton, minWidth: '180px' }}
          onClick={(e) => openNote(e, id)}
        >
          Add Note
        </Button>
      )
    }else if (checkDisabledNote(id)) {
      return (
        <Button
          id={id}
          style={{ ...addNoteButton, minWidth: '180px' }}
          onClick={(e) => updateNote(e, id)}
        >
          Update Note
        </Button>
      )
    }
  }

  function renderProperNote(id) {
    return noteLog
      .filter(entry => entry.id === id)
      .map((entry, index) => (
        <tr key={`note-${id}-${index}`} style={tbodyNote}>
          <td>Note: {entry.note}</td>
        </tr>
      ));
  }
  

  function noMatchesEndOfResultsA(lineItemZero) {
    if (data["no_match_a"] != null && data["no_match_b"] != null) {
      let a = JSON.parse(data["no_match_a"])
      let b = JSON.parse(data["no_match_b"])

      if (Object.keys(a).length > 0) {
        return Object.entries(a).map(([keys, vals]) => {
          const showDoc2 = doc2Visibility[keys] || false;
          const totalEntry = Object.entries(vals).find(
            ([k]) => k.toLowerCase() === "total"
          );

        return (
          <div
          className="redZone"
          style={{
            overflowY: "auto",
            overflowX: "hidden",
            borderBottom: "2px solid rgb(0, 179, 181)",
            padding: "0px 0px 10px 0px",
            margin: "5px 0px 10px 0px",
            backgroundColor: "#ffffff",
          }}
        >
          <a
            style={{
              display: "flex",
              justifyContent: "center",
              position: "relative",
              top: "40px",
              left: "0%",
              overflow: "hidden",
              zIndex: "9999",
              textAlign: "center",
              fontWeight: "bold",
              color: "rgb(0, 179, 181)",
              pointerEvents: "none",
              fontSize: "20px",
            }}
          >
            <img src={Stop} />
          </a>

          <table style={endOfDocTable} id={"zzz" + keys}>
            <thead style={theadStyle}>
              <tr>
                <th>
                  NOT FOUND IN ANY ZONE
                  <div
                    style={{
                      fontStyle: "italic",
                      fontSize: "13px",
                      color: "#526666",
                      padding: "2px 0px",
                      display: "inline",
                      margin: "2px",
                      float: "right",
                      cursor: "pointer",
                    }}
                    onClick={() => toggleDoc2Visibility(keys)}
                  >
                    Expand
                    <span
                      style={{
                        marginLeft: "8px",
                        display: "inline-block",
                        width: "0",
                        height: "0",
                        borderTop: "4px solid transparent",
                        borderBottom: "4px solid transparent",
                        borderLeft: "8px solid #526666",
                        transform: doc2Visibility[keys]
                          ? "rotate(90deg)"
                          : "rotate(0deg)",
                        transformOrigin: "4px 50%",
                        transition: "transform 0.2s ease",
                      }}
                    ></span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody id={"string"} key={keys} style={tbodyStyle}>
              <tr style={trStyle}>
                {Object.entries(vals)
                  .slice(0, 1)
                  .map(([key, val]) => {
                    const totalEntry = Object.entries(vals).find(
                      ([k]) => k.toLowerCase() === "total"
                    );

                    return (
                      <>
                        <th
                          style={{
                            ...thStyle,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "90%",
                          }}
                          key={key}
                        >
                          <span title={`${key}: ${val}`}>
                            {doc2Visibility[keys]
                              ? `${key}: ${val}`
                              : `${
                                  key.length > 20
                                    ? key.substring(0, 20) + "..."
                                    : key
                                }` +
                                `: ${
                                  val.length > 30
                                    ? val.substring(0, 30) + "..."
                                    : val
                                }`}
                          </span>

                          {!doc2Visibility[keys] && totalEntry && (
                            <span
                              style={{
                                fontWeight: "bold",
                                textAlign: "right",
                              }}
                            >
                              <span style={{ color: "#00B3B5" }}>
                                Total:
                              </span>
                              <span style={tdValueStyle}>
                                {totalEntry[1]}
                              </span>
                            </span>
                          )}
                        </th>
                      </>
                    );
                  })}
              </tr>
              {doc2Visibility[keys] && (
                <>
                  <tr style={trStyle}>
                    <th style={verticalLabel}>
                      {findDocNumber(keys)}
                      <span
                        style={{
                          cursor: "pointer",
                          color: "#00B3B5",
                          textDecoration: "underline",
                          zIndex: "1000",
                        }}
                        className={findDocNumber(keys) ? "doc1" : "doc2"}
                        onClick={async () => {
                          const isDoc1 = findDocNumber(keys);
                          const fieldName = isDoc1
                            ? "doc1_name"
                            : "doc2_name";
                          const currentName = isDoc1
                            ? data?.doc1_name
                            : data?.doc2_name;
                          const newName = window.prompt(
                            `Enter a new name for ${fieldName}:`,
                            currentName || "Unnamed"
                          );
                          if (newName !== null && newName.trim() !== "") {
                            try {
                              const claimId = comparisonID;
                              if (!claimId) {
                                console.error(
                                  "ERROR: Claim ID is missing!"
                                );
                                alert("Error: Claim ID is missing.");
                                return;
                              }
                              const requestBody = JSON.stringify({
                                [fieldName]: newName,
                              });
                              const response = await fetch(
                                `${process.env.REACT_APP_DOCNAMES}/${claimId}`,
                                {
                                  method: "PUT",
                                  headers: {
                                    "Content-Type": "application/json",
                                  },
                                  body: requestBody,
                                }
                              );
                              const result = await response.json();
                              if (!response.ok) {
                                throw new Error(
                                  result.error ||
                                    "Failed to update the database"
                                );
                              }
                              alert(`${fieldName} updated successfully!`);
                              if (isDoc1) {
                                setDoc1Name(newName);
                              } else {
                                setDoc2Name(newName);
                              }
                            } catch (error) {
                              console.error("ERROR:", error);
                              alert(
                                "Failed to update the database. Please try again."
                              );
                            }
                          }
                        }}
                      >
                        {findDocNumber(keys)
                          ? doc1Name
                          : doc2Name || "Unnamed"}
                      </span>
                    </th>
                    {Object.entries(vals)
                      .slice(1)
                      .map(([key, val]) => (
                        <tr id={key} key={key} style={containsPropVal}>
                          <td style={tdPropStyle}>{key}</td>
                          <td style={tdValueStyle}>{val}</td>
                        </tr>
                      ))}

                  </tr>
                </>
              )}
            </tbody>
            <tbody>{renderProperNote("zzz" + keys)}</tbody>
            <tbody style={tbodyStyle}>
              <tr style={lastRow}>
                {renderAddNote("zzz" + keys)}
                <div>
                  <label
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      fontStyle: "italic",
                      color: "#526666",
                      margin: "2px",
                    }}
                  >
                    <span
                      onClick={() => handleCheckedMatched("zzz" + keys)}
                      style={{
                        display: "inline-block",
                        width: "16px",
                        height: "16px",
                        marginRight: "8px",
                        border: "2px solid #526666",
                        borderRadius: "4px",
                        backgroundColor: handleStayCheckedMatched("zzz" + keys)
                          ? "#526666" // Checked state color
                          : "transparent",
                        cursor: "pointer",
                        position: "relative",
                        padding: "0 2px",
                      }}
                    >
                      {handleStayCheckedMatched("zzz" + keys) && (
                        <span
                          style={{
                            position: "absolute",
                            top: "-8px",
                            left: "0px",
                            fontSize: "24px",
                            color: "white", // Color for the checkmark
                            padding: "0 0 0 2px",
                            margin: "0",
                          }}
                        >
                          ✔
                        </span>
                      )}
                    </span>
                    {handleStayCheckedMatched("zzz" + keys)
                      ? "Confirmed No-Match"
                      : "Potential No-Match"}
                  </label>

               
                  <label style={{ display: 'flex', justifyContent: 'center', fontStyle: 'italic', color: '#526666', margin: '2px' }}>
                    <span
                      onClick={() => handleCheckboxChange("zzz" + keys)}
                      style={{
                        display: 'inline-block',
                        width: '16px',
                        height: '16px',
                        marginRight: '8px', // Spacing the checkbox before the label
                        border: '2px solid #526666',
                        borderRadius: '4px',
                        backgroundColor: markForExport.has("zzz" + keys)
                          ? '#526666' // Checked state color
                          : 'transparent',
                        cursor: 'pointer',
                        position: 'relative',
                        padding: '0 2px'
                      }}
                    >
                      {markForExport.has("zzz" + keys) && (
                        <span
                          style={{
                            position: 'absolute',
                            top: '-8px',
                            left: '0px',
                            fontSize: '24px',
                            color: 'white', // Color for the checkmark
                            padding: '0 0 0 2px',
                            margin: '0'
                          }}
                        >
                          ✔
                        </span>
                      )}
                    </span>
                    Mark For Export
                  </label>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
      );
    });
  }
}
}

  function noMatchesEndOfResultsB(lineItemZero) {
    if (data["no_match_a"] != null && data["no_match_b"] != null) {
      let a = JSON.parse(data["no_match_a"]);
      let b = JSON.parse(data["no_match_b"]);

      if (Object.keys(b).length > 0) {
        return Object.entries(b).map(([keys, vals]) => {
          const showDoc2 = doc2Visibility[keys] || false;
          const totalEntry = Object.entries(vals).find(
            ([k]) => k.toLowerCase() === "total"
          );
          return (
            <div
              className="redZone"
              style={{
                overflowY: "auto",
                overflowX: "hidden",
                borderBottom: "2px solid rgb(0, 179, 181)",
                padding: "0px 0px 10px 0px",
                margin: "5px 0px 10px 0px",
                backgroundColor: "#ffffff",
              }}
            >
              <a
                style={{
                  display: "flex",
                  justifyContent: "center",
                  position: "relative",
                  top: "40px",
                  left: "0%",
                  overflow: "hidden",
                  zIndex: "9999",
                  textAlign: "center",
                  fontWeight: "bold",
                  color: "rgb(0, 179, 181)",
                  pointerEvents: "none",
                  fontSize: "20px",
                }}
              >
                <img src={Stop} />
              </a>

              <table style={endOfDocTable} id={"zzz" + keys}>
                <thead style={theadStyle}>
                  <tr>
                    <th>
                      NOT FOUND IN ANY ZONE
                      <div
                        style={{
                          fontStyle: "italic",
                          fontSize: "13px",
                          color: "#526666",
                          padding: "2px 0px",
                          display: "inline",
                          margin: "2px",
                          float: "right",
                          cursor: "pointer",
                        }}
                        onClick={() => toggleDoc2Visibility(keys)}
                      >
                        Expand
                        <span
                          style={{
                            marginLeft: "8px",
                            display: "inline-block",
                            width: "0",
                            height: "0",
                            borderTop: "4px solid transparent",
                            borderBottom: "4px solid transparent",
                            borderLeft: "8px solid #526666",
                            transform: doc2Visibility[keys]
                              ? "rotate(90deg)"
                              : "rotate(0deg)",
                            transformOrigin: "4px 50%",
                            transition: "transform 0.2s ease",
                          }}
                        ></span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody id={"string"} key={keys} style={tbodyStyle}>
                  <tr style={trStyle}>
                    {Object.entries(vals)
                      .slice(0, 1)
                      .map(([key, val]) => {
                        const totalEntry = Object.entries(vals).find(
                          ([k]) => k.toLowerCase() === "total"
                        );

                        return (
                          <>
                            <th
                              style={{
                                ...thStyle,
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "90%",
                              }}
                              key={key}
                            >
                              <span title={`${key}: ${val}`}>
                                {doc2Visibility[keys]
                                  ? `${key}: ${val}`
                                  : `${
                                      key.length > 20
                                        ? key.substring(0, 20) + "..."
                                        : key
                                    }` +
                                    `: ${
                                      val.length > 30
                                        ? val.substring(0, 30) + "..."
                                        : val
                                    }`}
                              </span>

                              {!doc2Visibility[keys] && totalEntry && (
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    textAlign: "right",
                                  }}
                                >
                                  <span style={{ color: "#00B3B5" }}>
                                    Total:
                                  </span>
                                  <span style={tdValueStyle}>
                                    {totalEntry[1]}
                                  </span>
                                </span>
                              )}
                            </th>
                          </>
                        );
                      })}
                  </tr>
                  {doc2Visibility[keys] && (
                    <>
                      <tr style={trStyle}>
                        <th style={verticalLabel}>
                          {findDocNumber(keys)}
                          <span
                            style={{
                              cursor: "pointer",
                              color: "#00B3B5",
                              textDecoration: "underline",
                              zIndex: "1000",
                            }}
                            className={findDocNumber(keys) ? "doc1" : "doc2"}
                            onClick={async () => {
                              const isDoc1 = findDocNumber(keys);
                              const fieldName = isDoc1
                                ? "doc1_name"
                                : "doc2_name";
                              const currentName = isDoc1
                                ? data?.doc1_name
                                : data?.doc2_name;
                              const newName = window.prompt(
                                `Enter a new name for ${fieldName}:`,
                                currentName || "Unnamed"
                              );
                              if (newName !== null && newName.trim() !== "") {
                                try {
                                  const claimId = comparisonID;
                                  if (!claimId) {
                                    console.error(
                                      "ERROR: Claim ID is missing!"
                                    );
                                    alert("Error: Claim ID is missing.");
                                    return;
                                  }
                                  const requestBody = JSON.stringify({
                                    [fieldName]: newName,
                                  });
                                  const response = await fetch(
                                    `${process.env.REACT_APP_DOCNAMES}/${claimId}`,
                                    {
                                      method: "PUT",
                                      headers: {
                                        "Content-Type": "application/json",
                                      },
                                      body: requestBody,
                                    }
                                  );
                                  const result = await response.json();
                                  if (!response.ok) {
                                    throw new Error(
                                      result.error ||
                                        "Failed to update the database"
                                    );
                                  }
                                  alert(`${fieldName} updated successfully!`);
                                  if (isDoc1) {
                                    setDoc1Name(newName);
                                  } else {
                                    setDoc2Name(newName);
                                  }
                                } catch (error) {
                                  console.error("ERROR:", error);
                                  alert(
                                    "Failed to update the database. Please try again."
                                  );
                                }
                              }
                            }}
                          >
                            {findDocNumber(keys)
                              ? doc1Name
                              : doc2Name || "Unnamed"}
                          </span>
                        </th>
                        {Object.entries(vals)
                          .slice(1)
                          .map(([key, val]) => (
                            <tr id={key} key={key} style={containsPropVal}>
                              <td style={tdPropStyle}>{key}</td>
                              <td style={tdValueStyle}>{val}</td>
                            </tr>
                          ))}
                      </tr>
                    </>
                  )}
                </tbody>
                <tbody>{renderProperNote("zzz" + keys)}</tbody>
                <tbody style={tbodyStyle}>
                  <tr style={lastRow}>
                    <td>
                    {renderAddNote("zzz" + keys)}
                    </td>
                    <div>
                      <label
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          fontStyle: "italic",
                          color: "#526666",
                          margin: "2px",
                        }}
                      >
                        <span
                          onClick={() => handleCheckedMatched("zzz" + keys)}
                          style={{
                            display: "inline-block",
                            width: "16px",
                            height: "16px",
                            marginRight: "8px",
                            border: "2px solid #526666",
                            borderRadius: "4px",
                            backgroundColor: handleStayCheckedMatched("zzz" + keys)
                              ? "#526666" // Checked state color
                              : "transparent",
                            cursor: "pointer",
                            position: "relative",
                            padding: "0 2px",
                          }}
                        >
                          {handleStayCheckedMatched("zzz" + keys) && (
                            <span
                              style={{
                                position: "absolute",
                                top: "-8px",
                                left: "0px",
                                fontSize: "24px",
                                color: "white", // Color for the checkmark
                                padding: "0 0 0 2px",
                                margin: "0",
                              }}
                            >
                              ✔
                            </span>
                          )}
                        </span>
                        {handleStayCheckedMatched("zzz" + keys)
                          ? "Confirmed No-Match"
                          : "Potential No-Match"}
                      </label>
                      <label style={{ display: 'flex', justifyContent: 'center', fontStyle: 'italic', color: '#526666', margin: '2px' }}>
                        <span
                          onClick={() => handleCheckboxChange("zzz" + keys)}
                          style={{
                            display: 'inline-block',
                            width: '16px',
                            height: '16px',
                            marginRight: '8px', // Spacing the checkbox before the label
                            border: '2px solid #526666',
                            borderRadius: '4px',
                            backgroundColor: markForExport.has("zzz" + keys)
                              ? '#526666' // Checked state color
                              : 'transparent',
                            cursor: 'pointer',
                            position: 'relative',
                            padding: '0 2px'
                          }}
                        >
                          {markForExport.has("zzz" + keys) && (
                            <span
                              style={{
                                position: 'absolute',
                                top: '-8px',
                                left: '0px',
                                fontSize: '24px',
                                color: 'white', // Color for the checkmark
                                padding: '0 0 0 2px',
                                margin: '0'
                              }}
                            >
                              ✔
                            </span>
                          )}
                        </span>
                        Mark For Export
                      </label>
                    </div>
                  </tr>
                </tbody>
              </table>
            </div>
          );
        });
      }
    }
  }

  
  const getBackgroundSize = () => {
    return {
      backgroundSize: `${(percentValue * 100) / MAX}% 100%`,
    };
  }
  function validateRCV(val) {
    if (val == null) return null;
  
    const numVal = Number(val);
    const colorClass = numVal <= 0 ? "green" : "red";
    const displayVal = Math.abs(numVal).toFixed(2);
  
    return (
      <td className="differentials grey" key={`rcv-${val}`}>
        <b>Δ RCV: </b><strong className={colorClass}>{displayVal}</strong>
      </td>
    );
  }
  
  function validateACV(val) {
    if (val == null) return null;
  
    const numVal = Number(val);
    const colorClass = numVal <= 0 ? "green" : "red";
    const displayVal = Math.abs(numVal).toFixed(2);
  
    return (
      <td className="differentials grey" key={`acv-${val}`}>
        <b>Δ ACV: </b><strong className={colorClass}>{displayVal}</strong>
      </td>
    );
  }
  
  function validateTotal(key, val) {
    if (key === "Description Match Percent") {
      return (
        <td className="differentials grey" key={`total-${key}`}>
          <b>Δ Total: </b><strong>N/A</strong>
        </td>
      );
    }
  
    if (val == null) return null;
  
    const numVal = Number(val);
    const colorClass = numVal <= 0 ? "green" : "red";
    const displayVal = Math.abs(numVal).toFixed(2);
  
    return (
      <td className="differentials grey" key={`total-${key}`}>
        <b>Δ Total: </b><strong className={colorClass}>{displayVal}</strong>
      </td>
    );
  }
  

  const handleFilterChange = event => {
    setFilter(event.target.value)
  }

  if (data["claimData"] != null) {
    let resultsLayer = data[currentSection]
    let resLayer1 = Object.values(resultsLayer).map((val, i) => Object.values(val).slice(0, 1).toString())
    let noZone1Duplicates = [...new Set(resLayer1)]
    let resLayer2 = Object.values(resultsLayer).map((val, i) => (Object.values(val).slice(1, 2)).toString())
    let noZone2Duplicates = [...new Set(resLayer2)]
    doc1ZoneState.push(...noZone1Duplicates)
  }

  const handleSelect = (zone1Name, e) => {
    // Ensure zones are initialized first
    if (!zonesInitialized) {
      setZonesInitialized(true);
    }
    
    setNewZonesToCompare(current =>
      current.map(obj => {
        if (obj.Doc1 === zone1Name) {
          return {
            ...obj,
            SubZones: [e]
          };
        }
        return obj;
      })
    );
  };
  


  // Check if the container should stay checked
  const handleNewStayChecked = (container) => newViewArray.includes(container);

// Handle checkbox marking/unmarking
const handleNewChecked = (container) => {
  // Update newViewArray using Set
  setNewViewArray((prevSet) => {
    const updatedSet = new Set(prevSet);
    if (updatedSet.has(container)) {
      updatedSet.delete(container);
    } else {
      updatedSet.add(container);
    }
    return updatedSet;
  });

  // Update markForExport using Set
  setMarkForExport((prevSet) => {
    const updatedSet = new Set(prevSet);
    if (updatedSet.has(container)) {
      updatedSet.delete(container);
    } else {
      updatedSet.add(container);
    }
    return updatedSet;
  });
};


const confirmExportSelection = () => {
  //console.log("markForExport.size: " + markForExport.size);
  if (markForExport.size > 0) {
    // Convert the Set to an array and add to confirmedForExport
    setConfirmedForExport((prevSet) => new Set([...prevSet, ...markForExport]));

    // Add confirmed elements to pdfCopy
    const pdfCopy = document.getElementById('pdfCopy');
    const fragment = document.createDocumentFragment();  // Using DocumentFragment to minimize reflows

    // Create a parent div to wrap all containers
    const containerWrapper = document.createElement('div');
    containerWrapper.style.border = "4px solid #00B3B5";
    containerWrapper.style.boxSizing = "border-box";
    containerWrapper.style.width = "100%";
    containerWrapper.style.padding = "16px"; // Optional padding around the group of containers
    containerWrapper.style.marginBottom = "80px"; // Adjust the margin as needed
    containerWrapper.style.marginTop = "80px"; // Adjust the margin as needed

    // Iterate through the Set and process each key
    markForExport.forEach((key) => {
      const containerElement = document.getElementById(key);

      if (containerElement) {
        const clone = containerElement.cloneNode(true);
        clone.style.width = '100%';
        clone.style.boxSizing = "border-box";

        // Sanitize the ID to ensure it's a valid CSS selector
        const sanitizedId = key.replace(/[^a-zA-Z0-9-_]/g, '-');
        clone.id = `${sanitizedId}-pdfCopy`; // Unique ID for cloned element

        containerWrapper.appendChild(clone); // Append each cloned element to the container wrapper
      }
    });

    // Append the entire group of cloned containers inside the border to pdfCopy
    pdfCopy.appendChild(containerWrapper);

    // Clear the temporary selection Sets
    setMarkForExport(new Set());
    setNewViewArray(new Set());
  } else {
    alert("No selections made.");
  }
};

function handleSectionExport(id) {
 // console.log(`Processing section export for ID: ${id}`);

  const element = document.getElementById(id);
  if (!element) {
   // console.log(`Element with ID ${id} not found.`);
    return;
  }

  // Move up two levels to reach the grandparent container
  let grandparentDiv = element.parentElement?.parentElement?.parentElement;

  // Ensure the found element is a <div>
  if (!grandparentDiv || grandparentDiv.tagName !== "DIV") {
  //  console.log(`No valid grandparent div found for ${id}.`);
    return;
  }

  // Grab all tables inside this grandparent div
  const tableIds = [...grandparentDiv.querySelectorAll("table[id]")].map(
    (table) => table.id
  );

 // console.log(`Found ${tableIds.length} tables in grandparent div for ${id}:`, tableIds);

  setMarkAllCheckboxes((prevSet) => {
    const updatedMarkAll = new Set(prevSet);
    const isRemoving = updatedMarkAll.has(id);

    if (isRemoving) {
    //  console.log(`Removing ${id} from marked sections.`);
      updatedMarkAll.delete(id);
    } else {
    //  console.log(`Adding ${id} to marked sections.`);
      updatedMarkAll.add(id);
    }

    tableIds.forEach((tableId) => {
      setMarkForExport((prevSet) => {
        const updatedSet = new Set(prevSet);
        if (isRemoving) {
      //    console.log(`Removing table ${tableId} from export list.`);
          updatedSet.delete(tableId);
        } else {
       //   console.log(`Adding table ${tableId} to export list.`);
          updatedSet.add(tableId);
        }
        return updatedSet;
      });

      requestAnimationFrame(() => handlePDFClone(tableId, isRemoving));
    });

    return updatedMarkAll;
  });

 // console.log(`Completed processing for ${id}.`);
  return tableIds;
}


function handlePDFClone(tableId, isRemoving) {
  const element = document.getElementById(tableId);
  if (!element) return;

  const pdfCopy = document.getElementById("pdfCopy");
  if (!pdfCopy) return;

  const cloneId = `${tableId}-pdfCopy`;
  const existingClone = pdfCopy.querySelector(`#${CSS.escape(cloneId)}`);

  if (isRemoving) {
    existingClone && pdfCopy.removeChild(existingClone);
  } else if (!existingClone) {
    const elementClone = element.cloneNode(true);
    elementClone.id = cloneId;
    elementClone
      .querySelectorAll("button, input[type='checkbox'], label")
      .forEach((el) => el.remove());

    pdfCopy.appendChild(elementClone);
  }
}


const handleCheckboxChange = (lineItemZero) => {
  //console.log("handleCheckboxChange called with:", lineItemZero);

  setMarkForExport((prevSet) => {
    //console.log("Previous markForExport set:", prevSet);
    const updatedSet = new Set(prevSet);
    
    if (updatedSet.has(lineItemZero)) {
      //console.log("Removing from markForExport:", lineItemZero);
      updatedSet.delete(lineItemZero);
    } else {
      //console.log("Adding to markForExport:", lineItemZero);
      updatedSet.add(lineItemZero);
    }

    //console.log("Updated markForExport set:", updatedSet);
    return updatedSet;
  })

  requestAnimationFrame(() => {
    //console.log("Executing requestAnimationFrame callback");

    const element = document.getElementById(lineItemZero);
   // console.log("Element found by lineItemZero:", element);

    const pdfCopy = document.getElementById('pdfCopy');
    //console.log("pdfCopy container:", pdfCopy);

    if (element) {
      const cloneId = `${lineItemZero}-pdfCopy`;
      //console.log("Clone ID:", cloneId);

      const elementClone = element.cloneNode(true);
      elementClone.id = cloneId;
      //console.log("Cloned Element:", elementClone);

      // Remove unwanted elements from the clone
      elementClone.querySelectorAll('button, input[type="checkbox"], label').forEach(el => {
        //console.log("Removing element from clone:", el);
        el.remove();
      });

      if (markForExport.has(lineItemZero)) {
        const existingClone = pdfCopy.querySelector(`#${CSS.escape(cloneId)}`);
      //  console.log("Existing clone in pdfCopy:", existingClone);

        if (existingClone) {
          //console.log("Removing existing clone from pdfCopy.");
          pdfCopy.removeChild(existingClone);
        }
      } else {
        if (!pdfCopy.querySelector(`#${CSS.escape(cloneId)}`)) {
          //console.log("Appending cloned element to pdfCopy.");
          pdfCopy.appendChild(elementClone);
        } else {
         // console.log("Clone already exists in pdfCopy, skipping append.");
        }
      }
    }
  });
};

// Handle checked items for matched export (same logic for removing buttons, checkboxes, and labels)
const handleCheckedMatched = (lineItemZero) => {
  //handleCheckedMatched: " + lineItemZero);

  // Toggle the presence of `lineItemZero` in the markConfirm Set
  setMarkConfirm((prevSet) => {
    const newSet = new Set(prevSet);
    if (newSet.has(lineItemZero)) {
      newSet.delete(lineItemZero);
    } else {
      newSet.add(lineItemZero);
    }
    return newSet;
  });

  // Similarly, toggle the presence of `lineItemZero` in the markForExport Set
  setMarkForExport((prevSet) => {
    const newSet = new Set(prevSet);
    if (newSet.has(lineItemZero)) {
      newSet.delete(lineItemZero);
    } else {
      newSet.add(lineItemZero);
    }
    return newSet;
  });

  // Properly escape the ID to maintain spaces
  const escapedId = CSS.escape(lineItemZero);
  //console.log("Escaped ID:", escapedId);

  // Clone and add to pdfCopy for the matched export
  const element = document.getElementById(escapedId);
  const pdfCopy = document.getElementById('pdfCopy');

  if (element) {
    const elementClone = element.cloneNode(true);
    const cloneId = `${escapedId}-pdfCopy`; // Make the ID unique

    // Remove all button elements from the clone
    elementClone.querySelectorAll('button').forEach((button) => button.remove());

    // Remove all checkbox input elements from the clone
    elementClone.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => checkbox.remove());

    // Remove all label elements from the clone
    elementClone.querySelectorAll('label').forEach((label) => label.remove());

    if (markForExport.has(lineItemZero)) {
      // Remove from pdfCopy if the element is unmarked
      const existingClone = pdfCopy.querySelector(`#${CSS.escape(cloneId)}`);
      if (existingClone) {
        pdfCopy.removeChild(existingClone);
      }
    } else {
      // Add cloned element to pdfCopy if it's not already there
      if (!pdfCopy.querySelector(`#${CSS.escape(cloneId)}`)) {
        elementClone.id = cloneId; // Set unique ID for the cloned element
        pdfCopy.appendChild(elementClone); // Append to pdfCopy
      }
    }
  }
};



const handleStayChecked = (lineItemZero) => markForExport.has(lineItemZero);

const handleStayCheckedMatched = (lineItemZero) => {
  return 
};


function returnDoc2Zones(val) {
  return val
}

  function returnSubZonesArray(zone1Name, index) {
    if (newZonesToCompare[index]["SubZones"].length === 0) {
      return bestMatch(zone1Name)
    }
    else {
      return (
        newZonesToCompare[index]["SubZones"][0].map((val, i) => {
          return (val.name + "\t")
        })
      )
    }
  }

  function findDocNumber(key1) {
    if (key1 % 2 === 0) {
      return true
    }
    else {
      return false
    }
  }

 function dynamicPercentColorChange(val, totals, acv, rcv) {
  const green = {
    position: 'relative',
    height: 'auto',
    width: '100%',
    backgroundColor: '#bcf18b',
    borderRadius: '4px',
    padding: '0px 0px',
    margin: '10px 0px',
    overflow: 'auto',
    border: '1px dotted black'
  };

  const yellow = {
    position: 'relative',
    height: 'auto',
    width: '100%',
    backgroundColor: '#DDD3A0',
    borderRadius: '4px',
    padding: '0px 0px',
    margin: '10px 0px',
    overflow: 'auto',
    border: '1px dotted black'
  };

  const zero = {
    position: 'relative',
    height: 'auto',
    width: '100%',
    backgroundColor: '#b1d69e',  // darker green
    borderRadius: '4px',
    padding: '0px 0px',
    margin: '10px 0px',
    overflow: 'auto',
    border: '1px dotted black'
  };
  const keys = Object.keys(totals);

  if (val === 100 || (totals[keys[1]] == 0 && val >= 60) || (acv[keys[1]] === 0) || (rcv[keys[1]] === 0)) {    
    return zero;
  } else if (val >= 43) {
    return green;
  } else {
    return yellow;
  }
}



  // Example Usage:
  const val1 = 0; // Replace this with your actual value
  document.addEventListener("DOMContentLoaded", () => hideRedZoneIfValueIsZero(val1));


/* const [doc2Visibility, setDoc2Visibility] = React.useState({});

  const toggleDoc2Visibility = (key) => {
    setDoc2Visibility((prevState) => ({
      ...prevState,
      [key]: !prevState[key],  // Toggle visibility per item
    }));
  }; */

  function renderZones() {

  if(data["claimData"] && data["results"]){ 
    if(((Object.keys(data.results)).length === 0)) {
      return (
        <div>
          <p className={'loading-comparisons-text'}> Insufficient Results to Display... </p>
          <p> Data may not have been parsed properly from one of the two documents. </p>
        </div>
      ) 
    }  

      let resultsLayer = data[currentSection]
      let resLayer1 = Object.values(resultsLayer).map((val, i) => Object.values(val).slice(0, 1).toString())
      let noZone1Duplicates = [...new Set(resLayer1)]
      let resLayer2 = Object.values(resultsLayer).map((val, i) => (Object.values(val).slice(1, 2)).toString())
      let noZone2Duplicates = [...new Set(resLayer2)]
      doc1ZoneState.push(...noZone1Duplicates)
      let dropdown = noZone2Duplicates.map((zone2Name, index) => {
        return ({
          name: zone2Name,
          id: index
        })
      }

      )

      if (newZonesToCompare.length > 0) {
        return (
          <div>
            <div style={getZonePairingsContainer}>
              {noZone1Duplicates.map((zone1Name, index) =>
                <div style={mapStyle} key={index}>

                  <div>
                    <label style={labelStyle}>Showing Zone From Document 1: </label>
                    <label style={zoneStyle}>{zone1Name}</label>
                  </div>
                  <div>
                    <label style={labelStyle}>Showing Zone From Document 2: </label>
                    <label style={zoneStyle}>{returnSubZonesArray(zone1Name, index)}</label>
                    <Multiselect
                      options={dropdown}
                      id={zone1Name}
                      className="dropdown-style"
                      onSelect={(e) => handleSelect(zone1Name, e)}
                      onRemove={(e) => handleSelect(zone1Name, e)}
                      hidePlaceholder={true}
                      placeholder={" Change Zone(s) "}
                      isMulti
                      displayValue="name"
                    />
                  </div>
                  <div>
                    {Object.entries(resultsLayer).map(([zero, zones]) => {
                      const itemKey = zones["Zone 1"] + " vs. " + zones["Zone 2"] + " ";
                      const showDoc2 = doc2Visibility[itemKey] || false;
                      if (
                        (newZonesToCompare[index]["SubZones"].length === 0) &&
                        (Object.values(zones).slice(0, 1).includes(zone1Name)) &&
                        (Object.values(zones).slice(1, 2).includes(bestMatch(zone1Name).toString()))
                      ) {
                        return (
                        <div key={`zone-result-${index}-${zero}`}>
                        <div>
{/* ------------------------------------------------------------------------------------------------------------- */}
<ZoneDisplay1
  zones={zones}
  itemKey={itemKey}
  doc2ZoneStyle={doc2ZoneStyle}
  doc2Visibility={doc2Visibility}
  toggleDoc2Visibility={toggleDoc2Visibility}
  handleSectionExport={handleSectionExport}
  markAllCheckboxes={markAllCheckboxes}
  Stop={Stop}
  showDoc2={showDoc2}
  noMatchTableStyle={noMatchTableStyle}
  theadStyle={theadStyle}
  tbodyStyle={tbodyStyle}
  trStyle={trStyle}
  thStyle={thStyle}
  tdValueStyle={tdValueStyle}
  verticalLabel={verticalLabel}
  containsPropVal={containsPropVal}
  tdPropStyle={tdPropStyle}
  findDocNumber={findDocNumber}
  data={data}
  comparisonID={comparisonID}
  setDoc1Name={setDoc1Name}
  setDoc2Name={setDoc2Name}
  renderProperNote={renderProperNote}
  renderAddNote={renderAddNote}
  handleCheckedMatched={handleCheckedMatched}
  handleStayCheckedMatched={handleStayCheckedMatched}
  handleCheckboxChange={handleCheckboxChange}
  returnDoc2Zones={returnDoc2Zones}
  doc1Name={doc1Name}
  doc2Name={doc2Name}
  lastRow={lastRow}
  markForExport={markForExport}
/>

{/* ------------------------------------------------------------------------------------------------------------- */}
<ZoneDisplay2
  zones={zones}
  itemKey={itemKey}
  pdfRef={pdfRef}
  doc2Visibility={doc2Visibility}
  toggleDoc2Visibility={toggleDoc2Visibility}
  handleSectionExport={handleSectionExport}
  markAllCheckboxes={markAllCheckboxes}
  markForExport={markForExport}
  theadStyle={theadStyle}
  tbodyStyle={tbodyStyle}
  trStyle={trStyle}
  trStyleFlexStart={trStyleFlexStart}
  thStyle={thStyle}
  tdPropStyle={tdPropStyle}
  tdValueStyle={tdValueStyle}
  verticalLabel={verticalLabel}
  containsPropVal={containsPropVal}
  validateRCV={validateRCV}
  validateACV={validateACV}
  validateTotal={validateTotal}
  renderProperNote={renderProperNote}
  renderAddNote={renderAddNote}
  handleCheckboxChange={handleCheckboxChange}
  percentValue={percentValue}
  dynamicPercentColorChange={dynamicPercentColorChange}
  maxLength={maxLength}
  data={data}
  comparisonID={comparisonID}
  setDoc1Name={setDoc1Name}
  setDoc2Name={setDoc2Name}
  doc1Name={doc1Name}
  doc2Name={doc2Name}
  returnDoc2Zones={returnDoc2Zones}
  lastRow={lastRow}
  Yield={Yield}
  Close={Close}
  GO={GO}
/>

{/* ------------------------------------------------------------------------------------------------------------- */}
                        </div>
                        </div>
                        
                        )

                      } else if ((newZonesToCompare[index]["SubZones"].length > 0)) {
                        let subzones = (newZonesToCompare[index]["SubZones"]).map((obj, index) => {
                          return (
                            obj.map((obj2, index) => {
                              return obj2.name
                            })
                          )
                        })
                        for (let i = 0; i < subzones[0].length; i++) {
                          if (
                            (Object.values(zones).slice(0, 1).includes(zone1Name)) &&
                            (Object.values(zones).slice(1, 2).includes(subzones[0][i]))
                          ) {
                            return (
                              <div>
{/* ------------------------------------------------------------------------------------------------------------- */}
<ZoneDisplay1
  zones={zones}
  itemKey={itemKey}
  doc2ZoneStyle={doc2ZoneStyle}
  doc2Visibility={doc2Visibility}
  toggleDoc2Visibility={toggleDoc2Visibility}
  handleSectionExport={handleSectionExport}
  markAllCheckboxes={markAllCheckboxes}
  Stop={Stop}
  showDoc2={showDoc2}
  noMatchTableStyle={noMatchTableStyle}
  theadStyle={theadStyle}
  tbodyStyle={tbodyStyle}
  trStyle={trStyle}
  thStyle={thStyle}
  tdValueStyle={tdValueStyle}
  verticalLabel={verticalLabel}
  containsPropVal={containsPropVal}
  tdPropStyle={tdPropStyle}
  findDocNumber={findDocNumber}
  data={data}
  comparisonID={comparisonID}
  setDoc1Name={setDoc1Name}
  setDoc2Name={setDoc2Name}
  renderProperNote={renderProperNote}
  renderAddNote={renderAddNote}
  handleCheckedMatched={handleCheckedMatched}
  handleStayCheckedMatched={handleStayCheckedMatched}
  handleCheckboxChange={handleCheckboxChange}
  returnDoc2Zones={returnDoc2Zones}
  doc1Name={doc1Name}
  doc2Name={doc2Name}
  lastRow={lastRow}
  markForExport={markForExport}
/>
{/* ------------------------------------------------------------------------------------------------------------- */}
<ZoneDisplay2
  zones={zones}
  itemKey={itemKey}
  pdfRef={pdfRef}
  doc2Visibility={doc2Visibility}
  toggleDoc2Visibility={toggleDoc2Visibility}
  handleSectionExport={handleSectionExport}
  markAllCheckboxes={markAllCheckboxes}
  markForExport={markForExport}
  theadStyle={theadStyle}
  tbodyStyle={tbodyStyle}
  trStyle={trStyle}
  trStyleFlexStart={trStyleFlexStart}
  thStyle={thStyle}
  tdPropStyle={tdPropStyle}
  tdValueStyle={tdValueStyle}
  verticalLabel={verticalLabel}
  containsPropVal={containsPropVal}
  validateRCV={validateRCV}
  validateACV={validateACV}
  validateTotal={validateTotal}
  renderProperNote={renderProperNote}
  renderAddNote={renderAddNote}
  handleCheckboxChange={handleCheckboxChange}
  percentValue={percentValue}
  dynamicPercentColorChange={dynamicPercentColorChange}
  maxLength={maxLength}
  data={data}
  comparisonID={comparisonID}
  setDoc1Name={setDoc1Name}
  setDoc2Name={setDoc2Name}
  doc1Name={doc1Name}
  doc2Name={doc2Name}
  returnDoc2Zones={returnDoc2Zones}
  lastRow={lastRow}
  Yield={Yield}
  Close={Close}
  GO={GO}
/>
{/* ------------------------------------------------------------------------------------------------------------- */}
                          </div>
                            )
                          }
                        }
                      }
                    }
                    )}
                  </div>

                </div>

              )}

              <div style={borderTop}>
                {noMatchesEndOfResultsA('zzz')}
                {noMatchesEndOfResultsB('zzz')}
              </div>
            </div>
          </div>
        )
      }
    }

  }


  function bestMatch(zone1Name) {
    if (data["claimData"] != null) {
      let resultsLayer = data[currentSection]
      let resLayer1 = Object.values(resultsLayer).map((val, i) => Object.values(val).slice(0, 1).toString())
      let noZone1Duplicates = [...new Set(resLayer1)]
      let resLayer2 = Object.values(resultsLayer).map((val, i) => (Object.values(val).slice(1, 2)).toString())
      let noZone2Duplicates = [...new Set(resLayer2)]
      return (
        Object.entries(stringSimilarity.findBestMatch(zone1Name, noZone2Duplicates)).slice(1, 2).map(([key, val]) =>
          Object.entries(val).slice(0, 1).map(([key2, val2]) => {
            return (
              val2
            )
          }
          )))
    }
  }

  function toggleView() {
    setToggled(!toggled)
  }


  // Filter line items based on selected zones and filter text
  const filterLineItems = () => {
    if (!data.results) return;

    const filteredZone1Items = [];
    const filteredZone2Items = [];

    const zone1Set = new Set();
    const zone2Set = new Set();

    Object.entries(data.results).forEach(([key, item]) => {
      const zone1Name = item["Zone 1"];
      const zone2Name = item["Zone 2"];

      Object.entries(item["Line Items"]).forEach(([lineItemKey, lineItemValue]) => {
        const line1Key = `${zone1Name}-${lineItemValue["Line Item 1"]?.DESCRIPTION || ""}`;
        const line2Key = `${zone2Name}-${lineItemValue["Line Item 2"]?.DESCRIPTION || ""}`;

        // Function to check if filter text exists in line item properties
        const matchesFilterZone1 = (lineItem) => {
          return Object.values(lineItem).some(value =>
            value.toString().toLowerCase().includes(filterTextZone1.toLowerCase())
          );
        };

        const matchesFilterZone2 = (lineItem) => {
          return Object.values(lineItem).some(value =>
            value.toString().toLowerCase().includes(filterTextZone2.toLowerCase())
          );
        };

        // Add Line Item 1 to Zone 1 items if it matches the filter text for Document 1
        if (
          (selectedZone1.length === 0 || selectedZone1.includes(zone1Name)) &&
          lineItemValue["Line Item 1"] &&
          !zone1Set.has(line1Key) &&
          matchesFilterZone1(lineItemValue["Line Item 1"])
        ) {
          zone1Set.add(line1Key);
          filteredZone1Items.push({ zone: zone1Name, item: lineItemValue["Line Item 1"] });
        }

        // Add Line Item 2 to Zone 2 items if it matches the filter text for Document 2
        if (
          (selectedZone2.length === 0 || selectedZone2.includes(zone2Name)) &&
          lineItemValue["Line Item 2"] &&
          !zone2Set.has(line2Key) &&
          matchesFilterZone2(lineItemValue["Line Item 2"])
        ) {
          zone2Set.add(line2Key);
          filteredZone2Items.push({ zone: zone2Name, item: lineItemValue["Line Item 2"] });
        }
      });
    });

    setFilteredItems({ zone1: filteredZone1Items, zone2: filteredZone2Items });
  };

  const handleZone1Change = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
    setSelectedZone1(selectedValues);
  };

  const handleZone2Change = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
    setSelectedZone2(selectedValues);
  };

  const handleFilterTextZone1Change = (event) => {
    setFilterTextZone1(event.target.value);
  };

  const handleFilterTextZone2Change = (event) => {
    setFilterTextZone2(event.target.value);
  };

  const handleDoc1NameChange = (event) => {

  }
  // You can then merge this style into the sx prop if you're using it inline with your Button.

  const handleFocus = () => {

    if (newViewArray.length > 0) {
      if (!window.confirm('Changing the filters will clear your selections. Proceed?')) {
        return;
      }
    }

    setNewViewArray([]);
  };

  const renderView = () => {
    const zone1Set = new Set();
    const zone2Set = new Set();

    if (data.results) {
      Object.entries(data.results).forEach(([key, item]) => {
        if (item["Zone 1"]) zone1Set.add(item["Zone 1"]);
        if (item["Zone 2"]) zone2Set.add(item["Zone 2"]);
      });
    }

    const uniqueZone1s = Array.from(zone1Set).map(zone => ({ value: zone, label: zone }));
    const uniqueZone2s = Array.from(zone2Set).map(zone => ({ value: zone, label: zone }));
    const clearFilterText1 = () => {
      setFilterTextZone1('');
    };
    const clearFilterText2 = () => {
      setFilterTextZone2('');
    };

    const truncateValue = (value) => {
      return value.length > 60 ? value.slice(0, 60) + '...' : value;
    };

    return (
      <div>
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
          <div onClick={handleFocus}>
            <label>Doc 1 Zones: </label>
            <Select
              isMulti
              value={uniqueZone1s.filter(opt => selectedZone1.includes(opt.value))}
              onChange={handleZone1Change}
              options={uniqueZone1s}
              placeholder="Select Zone"
            />
            <br />
            <label>Filter (Doc 1): </label>
            <input
              style={filterStyle}
              type="text"
              value={filterTextZone1}
              onChange={handleFilterTextZone1Change}
              placeholder="Enter text to filter"
            />
            {filterTextZone1 && (
              <button
                onClick={clearFilterText1}
                style={{
                  transform: 'translateX(-150%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '16px',
                }}
              >
                ×
              </button>
            )}

          </div>

          <div onClick={handleFocus}>
            <label>Doc 2 Zones: </label>
            <Select
              isMulti
              value={uniqueZone2s.filter(opt => selectedZone2.includes(opt.value))}
              onChange={handleZone2Change}
              options={uniqueZone2s}
              placeholder="Select Zone"
            />
            <br />
            <label>Filter (Doc 2): </label>
            <input
              style={filterStyle}
              type="text"
              value={filterTextZone2}
              onChange={handleFilterTextZone2Change}
              placeholder="Enter text to filter"
            />
            {filterTextZone2 && (
              <button
                onClick={clearFilterText2}
                style={{
                  transform: 'translateX(-150%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '16px',
                }}
              >
                ×
              </button>
            )}
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
          <div style={{ flex: 1, marginRight: '10px', boxSizing: 'border-box' }}>
            {filteredItems.zone1.length > 0 ? (
              filteredItems.zone1.map((entry, index) => {
                // Create a unique ID using the entry's zone and the index
                const uniqueId = `Doc-1-${entry.zone}-${index}`;

                return (
                  <div id={uniqueId} key={uniqueId}>
                    <div style={filterTableStyle}>
                      {/* Display the first entry on top */}
                      {Object.entries(entry.item).slice(0, 1).map(([key, value]) => (
                        <div key={key} style={blockStyle}>
                          <h4 style={centeredHeader}> (Doc 1) Zone: {entry.zone}</h4>
                          <hr />
                          <br />
                          <div style={thStyle}>{key}: {truncateValue(value)}</div>
                          <br />
                        </div>
                      ))}

                      {/* Display the rest of the entries below */}
                      <div style={trStyle}>
                        {Object.entries(entry.item).slice(1).map(([key, value]) => (
                          <div key={key}>
                            <div style={tdPropStyle}>{key}</div>
                            <div style={tdValueStyle}>{value}</div>
                            <br />
                          </div>
                        ))}
                      </div>

                      <label style={{ display: 'flex', justifyContent: 'center', fontStyle: 'italic', color: '#526666', margin: '2px' }}>
                        <span
                          onClick={() => handleCheckboxChange(uniqueId)}
                          style={{
                            display: 'inline-block',
                            width: '16px',
                            height: '16px',
                            marginRight: '8px', // Spacing the checkbox before the label
                            border: '2px solid #526666',
                            borderRadius: '4px',
                            backgroundColor: markForExport.has(uniqueId)
                              ? '#526666' // Checked state color
                              : 'transparent',
                            cursor: 'pointer',
                            position: 'relative',
                            padding: '0 2px'
                          }}
                        >
                          {markForExport.has(uniqueId) && (
                            <span
                              style={{
                                position: 'absolute',
                                top: '-8px',
                                left: '0px',
                                fontSize: '24px',
                                color: 'white', // Color for the checkmark
                                padding: '0 0 0 2px',
                                margin: '0'
                              }}
                            >
                              ✔
                            </span>
                          )}
                        </span>
                        Mark For Export
                      </label>
                    </div>
                  </div>
                );
              })
            ) : (
              <p>No line items for Doc 1.</p>
            )}
          </div>

          <div style={{ flex: 1, marginLeft: '10px', boxSizing: 'border-box' }}>
            {filteredItems.zone2.length > 0 ? (
              filteredItems.zone2.map((entry, index) => {
                // Create a unique ID using the entry's zone and the index
                const uniqueId = `Doc-2-${entry.zone}-${index}`;

                return (
                  <div id={uniqueId} key={uniqueId}>
                    <div style={filterTableStyle}>
                      {/* Display the first entry on top */}
                      {Object.entries(entry.item).slice(0, 1).map(([key, value]) => (
                        <div key={key} style={blockStyle}>
                          <h4 style={centeredHeader}>(Doc 2) Zone: {entry.zone}</h4>
                          <hr />
                          <br />
                          <div style={thStyle}>{key}: {truncateValue(value)}</div>
                          <br />
                        </div>
                      ))}

                      {/* Display the rest of the entries below */}
                      <div style={trStyle}>
                        {Object.entries(entry.item).slice(1).map(([key, value]) => (
                          <div key={key}>
                            <div style={tdPropStyle}>{key}</div>
                            <div style={tdValueStyle}>{value}</div>
                            <br />
                          </div>
                        ))}
                      </div>
                                          
                      <label style={{ display: 'flex', justifyContent: 'center', fontStyle: 'italic', color: '#526666', margin: '2px' }}>
                        <span
                          onClick={() => handleCheckboxChange(uniqueId)}
                          style={{
                            display: 'inline-block',
                            width: '16px',
                            height: '16px',
                            marginRight: '8px', // Spacing the checkbox before the label
                            border: '2px solid #526666',
                            borderRadius: '4px',
                            backgroundColor: markForExport.has(uniqueId)
                              ? '#526666' // Checked state color
                              : 'transparent',
                            cursor: 'pointer',
                            position: 'relative',
                            padding: '0 2px'
                          }}
                        >
                          {markForExport.has(uniqueId) && (
                            <span
                              style={{
                                position: 'absolute',
                                top: '-8px',
                                left: '0px',
                                fontSize: '24px',
                                color: 'white', // Color for the checkmark
                                padding: '0 0 0 2px',
                                margin: '0'
                              }}
                            >
                              ✔
                            </span>
                          )}
                        </span>
                        Mark For Export
                      </label>
                    </div>
                  </div>
                );
              })
            ) : (
              <p>No line items for Doc 2.</p>
            )}
          </div>
        </div>
      </div>
    );
  };


  return (
    <div className={'outer-container'}>
      <MainWrapper />
      <div className={'right-container'}>
        <div className={'comparison-results-container'}>
          <h1 className={'h1-comparison-results'}>
            {toggled ? 'Comparison Results - Zone by Zone' : 'Comparison Results - Filter by Descriptions'}
          </h1>

          <div className={'comparison-results-actions-div'}>
            <button onClick={handleClick} className="hamburger-button">&#x22EE;</button>
            {menuOpen && (
              <ul className="dropdown-menu">
                <li onClick={() => { toggleView(); handleClose(); }}>Toggle View</li>
                {toggled && <li onClick={() => { saveChanges(comparisonID); handleClose(); }}>Save Changes</li>}
                {toggled && (
                  <li>
                    <label className="filter-label" htmlFor="filter-percentage">
                      LEVLR Match Assistance
                    </label>
                    <input
                      id="filter-percentage"
                      type="range"
                      min="0"
                      max={MAX}
                      onChange={(e) => setPercentValue(e.target.value)}
                      style={getBackgroundSize()}
                      value={percentValue}
                    />
                  </li>
                )}
                {/* Add the export buttons as list items */}
                {!toggled && (
                  <li style={{animation: newViewArray.length > 0 ? 'fluctuateColor 2s infinite alternate' : 'none'}} onClick={confirmExportSelection}>
                    
                      Add Selections To PDF
                  </li>
                )}
                <li onClick={openPreviewInNewTab}>
                    Preview PDF
                </li>
                <li  
                    onClick={() => {
                      if (newViewArray.length > 0) {
                        alert("You have selections that are not added to the PDF!");
                      } else {
                        generatePDF(); 
                      }
                    }}>
                    Export PDF
                </li>
              </ul>
            )}
          </div>


          <div id={'pairings'} className={'pairings-container'}>
            <div className={loadingStatus}></div>
            {toggled ? (
              <>
                {renderZones()}
                {renderNote()}
              </>
            ) : (
              renderView()
            )}
          </div>
        </div>
      </div>

      <div style={pdfCopy} id={'pdfCopy'}>
        {renderClaimCredentials()}
      </div>
    </div>
  );
};
export default ComparisonResults